// TODO: move models/system.ts to shared and reuse from there
var Locale;
(function (Locale) {
    Locale["DE"] = "de";
    Locale["EN"] = "en";
})(Locale || (Locale = {}));
export const isDevelopment = import.meta.env.MODE !== 'production';
export const isB2B = typeof window !== 'undefined' && window.location.host.includes('b2b');
if (isDevelopment) {
    console.warn('Running in development mode');
    console.warn(import.meta.env.MODE);
}
export const APP_VERSION = '0.0.1';
export const API = import.meta.env.VITE_API_URL ||
    (isDevelopment
        ? 'https://api.staging.starjack.at/'
        : 'https://api.starjack.at/');
export const DEFAULT_API_VERSION = 'v1/';
export const DATE_FORMAT = 'dd.MM.yyyy';
export const DATE_TIME_FORMAT = 'dd.MM.yyyy HH:mm';
export const DATE_FORMAT_DISPLAY = 'DD.MM.JJJJ';
export const DATE_FORMAT_BACKEND_STRING = 'yyyy-MM-dd';
export const WEEKDAYS = {
    MONDAY: 'Montag',
    TUESDAY: 'Dienstag',
    WEDNESDAY: 'Mittwoch',
    THURSDAY: 'Donnerstag',
    FRIDAY: 'Freitag',
    SATURDAY: 'Samstag',
    SUNDAY: 'Sonntag',
};
export const ACCEPTED_FILES_IMAGE = {
    'image/jpeg': ['.jpg', '.jpeg'],
    'image/png': ['.png'],
};
export const locale = Locale.DE;
